module.exports = __webpack_public_path__ + "static/img/service-database.444392dd.png";